import { Dayjs } from "dayjs";

const getRemainingMonthsInYear = (currentDate: Dayjs) => {
	const currentMonth = currentDate.month();
	const remainingMonths = [];

	for (let i = currentMonth + 1; i <= 11; i++) {
		const month = currentDate.month(i).format("MMM");
		remainingMonths.push(month);
	}

	return remainingMonths;
};

export default getRemainingMonthsInYear;
